<template>
	<div class="brand-tabs" v-if="brandId">
		<button class="tab" :class="{ active: active === 'chemical' }" @click="go('chemical')">
			화학물질 <b>{{ countText(chemicalCount) }}</b>
		</button>
		<button class="tab" :class="{ active: active === 'supplies' }" @click="go('supplies')">
			실험용품/기기 <b>{{ countText(suppliesCount) }}</b>
		</button>
	</div>
</template>

<script>
import PageName from '@/utils/define/PageName'
import catalogAPI from '@/services/api/catalog'
import suppliesAPI from '@/services/api/supplies'

// 브랜드 하나에 대해 화학물질 / 실험용품·기기 건수를 보여주고 서로 오갈 수 있게 하는 탭.
export default {
	name: 'BrandTabs',
	props: {
		brandId: {
			type: [Number, String],
			default: null,
		},
		// 현재 화면: chemical | supplies
		active: {
			type: String,
			default: 'chemical',
		},
		// 현재 화면에 상품이 없고 반대편에만 있으면 그쪽으로 바로 보낸다.
		autoRedirect: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			chemicalCount: null,
			suppliesCount: null,
		}
	},
	watch: {
		brandId: {
			immediate: true,
			handler() {
				this.load()
			},
		},
	},
	methods: {
		countText(count) {
			return count === null ? '' : `${Number(count).toLocaleString('ko-KR')}건`
		},
		async load() {
			if (!this.brandId) return
			const id = Number(this.brandId)
			this.chemicalCount = this.suppliesCount = null
			const [chemical, supplies] = await Promise.all([
				catalogAPI
					.lookupCatalogList({
						keyword: '',
						keywordType: 'TEXT',
						keywordTarget: 'ALL',
						offset: 0,
						length: 1,
						order: ['FAVORITE'],
						orderDirection: ['DESC'],
						sellerIds: [],
						brandIds: [id],
						categoryKorName: '화학물질',
						tags: [],
					})
					.then(({ data }) => Number(data.count) || 0)
					.catch(() => null),
				suppliesAPI
					.lookupList({ brandIds: [id], offset: 0, length: 1 })
					.then(({ data }) => Number(data.count) || 0)
					.catch(() => null),
			])
			// 그 사이 브랜드가 바뀌었으면 버린다.
			if (id !== Number(this.brandId)) return
			this.chemicalCount = chemical
			this.suppliesCount = supplies
			const mine = this.active === 'chemical' ? chemical : supplies
			const other = this.active === 'chemical' ? supplies : chemical
			if (this.autoRedirect && mine === 0 && other > 0) this.go(this.active === 'chemical' ? 'supplies' : 'chemical', true)
		},
		go(target, replace = false) {
			if (target === this.active) return
			const location =
				target === 'supplies'
					? { name: PageName.Supplies, query: { b: String(this.brandId) } }
					: { path: '/search/brand', query: { id: String(this.brandId) } }
			const action = replace ? this.$router.replace(location) : this.$router.push(location)
			action.catch(() => {})
		},
	},
}
</script>

<style lang="scss" scoped>
.brand-tabs {
	display: flex;
	gap: 8px;
	margin: 0 0 18px;
	.tab {
		padding: 9px 20px;
		border: 1px solid #dfe3e8;
		border-radius: 22px;
		background: #fff;
		font-size: 0.95rem;
		font-weight: 600;
		color: #4b5563;
		transition: all 0.15s;
		b {
			margin-left: 4px;
			font-weight: 700;
			color: #98a2ad;
		}
		&:hover {
			border-color: #1d4f80;
		}
		&.active {
			border-color: #1d4f80;
			background: #1d4f80;
			color: #fff;
			b {
				color: rgba(255, 255, 255, 0.8);
			}
		}
	}
}
</style>
